import React from 'react';
export const LocationSvg: React.FC = () => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9.9575C1 5.01069 5.02975 1 10 1C14.9703 1 19 5.01069 19 9.9575C19 14.8658 16.1279 20.5947 11.6459 22.6419C11.1307 22.8777 10.5688 23 10 23C9.43116 23 8.86928 22.8777 8.35412 22.6419C3.87212 20.5936 1 14.8669 1 9.9586V9.9575Z"
        stroke="#535761"
        strokeWidth="1.5"
      />
      <path
        d="M9.889 13C11.7299 13 13.2223 11.5348 13.2223 9.72732C13.2223 7.91984 11.7299 6.45459 9.889 6.45459C8.04805 6.45459 6.55566 7.91984 6.55566 9.72732C6.55566 11.5348 8.04805 13 9.889 13Z"
        stroke="#535761"
        strokeWidth="1.5"
      />{' '}
    </svg>
  );
};
